// number of similar jobs we display at the bottom of the job details page
export const SIMILAR_JOBS_BOTTOM_LIMIT = 9;
// number of similar jobs we display at the top
export const SIMILAR_JOBS_TOP_LIMIT = 3;
// number of jobs we ask to the BE
export const SIMILAR_JOBS_LIMIT =
  SIMILAR_JOBS_BOTTOM_LIMIT + SIMILAR_JOBS_TOP_LIMIT;
